import React from "react";
import "./AIConversationPage.css";

const AIConversationPage = () => {
  // Updated to point to the external AI agent page as requested
  const targetUrl = "https://xiaotai.tangledup-ai.com/agent/41"; 

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
      <iframe 
        src={targetUrl}
        style={{ 
          width: '100%', 
          height: '100%', 
          border: 'none',
          display: 'block' 
        }}
        allow="microphone; camera; autoplay; clipboard-write"
        title="AI Conversation"
      />
    </div>
  );
};

export default AIConversationPage;
